import React, { useState, useContext, useEffect } from "react";
import { motion, AnimateSharedLayout } from "framer-motion";
import { Link, useHistory } from "react-router-dom";

import { ReactComponent as Logo } from "../assets/smallLogo.svg";
import LoginLogoutButton from "./LoginLogoutButton";

import { ThemeContext } from "../context/theme";

const pages = [{ name: "Home", route: "/" }];

export default function Navbar() {
  const theme = useContext(ThemeContext);
  const history = useHistory();

  const [navPage, setNavPage] = useState("");

  useEffect(() => {
    setNavPage(history.location.pathname);
  }, [history.location.pathname]);

  console.log(navPage);

  const headers = pages.map((page) => {
    const textOffset = () => {
      if (navPage === page.route) {
        return "1px";
      } else {
        return "0em";
      }
    };

    return (
      <div>
        <div style={{ paddingLeft: 60, paddingRight: 60 }}>
          <Link
            onClick={() => {
              setNavPage(page.route);
            }}
            to={page.route}
            style={{
              color: "white",
              textDecoration: "none",
              fontSize: 24,
              fontFamily: "Spectral SC",
              position: "relative",
              top: textOffset(),
              fontWeight: 500,
            }}
          >
            <p>{page.name}</p>
          </Link>
        </div>
        {navPage === page.route && (
          <motion.div
            layoutId="navUnderline"
            initial={false}
            transition={{
              type: "spring",
              stiffness: 2000,
              damping: 100,
            }}
            name="Active Line"
            style={{
              background: theme.primary,
              height: "2px",
              position: "relative",
              top: "3px",
              marginLeft: 10,
              marginRight: 10,
              borderRadius: 3,
              zIndex: 1,
            }}
          ></motion.div>
        )}
      </div>
    );
  });

  return (
    <div
      style={{
        zIndex: 2,
        width: "100%",
        background: theme.background,
        borderBottom: "2px solid #5A5A62",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div name="Left Side">
        <AnimateSharedLayout>
          <nav
            style={{
              display: "flex",
              alignItems: "center",
              height: 40,
            }}
          >
            <Logo
              style={{
                height: 25,
                width: 25,
                paddingLeft: 15,
                paddingRight: 15,
              }}
            />
            {headers}
          </nav>
        </AnimateSharedLayout>
      </div>
      <div name="Right Side" style={{ paddingRight: 15 }}></div>
    </div>
  );
}
